import { Fragment } from "react";
import { StatusPill } from "@/shared/components/status-pill";
import { capitalize } from "@/shared/lib/utils";

export type DetailHeaderMetadataItemProps = {
  label: string;
  value: string;
  isStatus?: boolean;
  showSeparator?: boolean;
};

export function DetailHeaderMetadataItem({
  label,
  value,
  isStatus = false,
  showSeparator = false,
}: DetailHeaderMetadataItemProps) {
  return (
    <Fragment>
      <span className="font-semibold">{label}:</span>{" "}
      {isStatus ? (
        <StatusPill status={value} />
      ) : (
        <span>{capitalize(value)}</span>
      )}
      {showSeparator && <span>•</span>}
    </Fragment>
  );
}
